import { render, staticRenderFns } from "./DashboardFull.vue?vue&type=template&id=6468bfe4"
import script from "./DashboardFull.vue?vue&type=script&lang=js"
export * from "./DashboardFull.vue?vue&type=script&lang=js"
import style0 from "./DashboardFull.vue?vue&type=style&index=0&id=6468bfe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports